import {HubApi} from './hub-api';
import {HubInstances} from '../hub-instances';
import {BaseApiWrapper} from '../base-api-wrapper';

export class HubApiBuilder extends BaseApiWrapper {
    private triumphUrl: string;
    private tbUrl: string;

    public constructor(triumphUrl: string, tbUrl: string) {
        super();
        this.triumphUrl = triumphUrl;
        this.tbUrl = tbUrl;
    }

    public getForGame(game: HubInstances): HubApi {
        let hubApi: HubApi;

        switch (game) {
            case HubInstances.TRIUMPH:
                hubApi = new HubApi(this.triumphUrl, this.tbUrl);
                break;
            case HubInstances.TOTALBATTLE:
                hubApi = new HubApi(this.tbUrl);
                break;
            default:
                throw new Error('Unknown game');
        }

        if (this.loggingAdapter) {
            hubApi.setLoggingAdapter(this.loggingAdapter);
        }

        if (this.metricsAdapter) {
            hubApi.setMetricsAdapter(this.metricsAdapter);
        }

        return hubApi;
    }
}
